<div class='gray-background' (click)="closeModal()"></div>
<div class='create-reset-password-modal-wrapper'>
  <div class='main-title'>{{ 'LOGIN.RESET_PASSWORD' | translate }}</div>
  <div class='data-wrapper'>
    <div class="email-title">{{ 'LOGIN.PASSWORD' | translate }}</div>
    <input type="password" class="email-input" placeholder="{{ 'LOGIN.INSERT_PASSWORD' | translate }}" [(ngModel)]="password"/>
    <div class="email-title">{{ 'LOGIN.CONFIRM_PASS' | translate }}</div>
    <input type="password" class="email-input" placeholder="{{ 'LOGIN.RETYPE_PASS' | translate }}" [(ngModel)]="confirmPassword" [ngClass]="{'error-input': passwordMatchFlag}"/>
    @if (passwordMatchFlag) {
      <div class="error-flag">
        <img class='error-icon' src="assets/images/login/error.png" alt="" />
        <div rtlDiv>{{ 'LOGIN.INCORRECT_PASS' | translate }}</div>
      </div>
    }
    @if(token_expired){
      <div class="error-flag">
        <img class='error-icon' src="assets/images/login/error.png" alt="" />
        <div rtlDiv>{{ 'LIST_COLUMNS.TOKEN_EXPIRED' | translate }}</div>
      </div>
    }
    @if(token_not_exist){
      <div class="error-flag">
        <img class='error-icon' src="assets/images/login/error.png" alt="" />
        <div rtlDiv>{{ 'LIST_COLUMNS.TOKEN_NOT_EXIST' | translate }}</div>
      </div>
    }
    @if(password_error){
      <div class="error-flag">
        <img class='error-icon' src="assets/images/login/error.png" alt="" />
        <div rtlDiv>{{ 'LIST_COLUMNS.INVALID_PASS_MSG' | translate }}</div>
      </div>
    }
  </div>
  <div class='main-btns-wrapper'>
    <div class='btns-container'>
      <div class='cancel-btn' (click)="closeModal()">{{ 'LOGIN.CANCEL' | translate }}</div>
      <div class='apply-btn' (click)='sendNewPassword(password, confirmPassword )'>{{ 'LOGIN.SEND' | translate }}</div>
    </div>
  </div>
</div>